import { render, staticRenderFns } from "./CourseSelector.vue?vue&type=template&id=65d478bf&scoped=true"
import script from "./CourseSelector.vue?vue&type=script&lang=js"
export * from "./CourseSelector.vue?vue&type=script&lang=js"
import style0 from "./CourseSelector.vue?vue&type=style&index=0&id=65d478bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d478bf",
  null
  
)

export default component.exports